import { CSSProperties } from 'react';
import { useLingui } from '@lingui/react/macro';

import { InputSelect } from '@/design_system/InputSelect/InputSelect';
import { useCompanies } from '@/models/company';

export const InvoiceLineOriginSelect = ({
  setPage,
  invoiceLineOrigin,
  setInvoiceLineOrigin,
  style,
}: {
  setPage?: (page: number) => void;
  invoiceLineOrigin: string;
  setInvoiceLineOrigin: (workshop: string) => void;
  style?: CSSProperties;
}) => {
  const { t } = useLingui();

  const { data, isFetching } = useCompanies({ limit: 100, traits: ['workshop'] });

  const options = data?.companies ?? [];

  const selectedOption = options.find((option) => option.id === invoiceLineOrigin) ?? null;

  if (!options.length) {
    return null;
  }

  return (
    <InputSelect
      variant="select"
      placeholder={t({
        id: 'accounting.invoice-lines.issuer.placeholder',
        message: 'Issuer: All',
      })}
      aria-label={t({ id: 'accounting.invoice-lines.issuer.label', message: 'Issuer' })}
      value={selectedOption}
      isClearable
      options={options}
      getOptionValue={(option) => option.id}
      getOptionLabel={(option) => option.name}
      onChange={(option, action) => {
        if (action.action === 'clear') {
          setInvoiceLineOrigin('');
        } else if (option) {
          setInvoiceLineOrigin(option.id);
        }

        setPage?.(1);
      }}
      isLoading={isFetching}
      style={style}
    />
  );
};
